var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade show modal-mask",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "id": "myModal",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    class: [_vm.large ? 'modal-dialog modal-lg modal-dialog-centered' : '', 'modal-dialog'],
    style: _vm.width ? {
      maxWidth: _vm.width + 'px'
    } : {},
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("header", function () {
    return [_c('i', {
      class: _vm.element_list['icon']
    }), _vm._v("\n              " + _vm._s(_vm.element_list['title']) + "\n            ")];
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "auto"
    },
    style: _vm.element_list['style']
  }, [_vm.tab_form ? _c('b-form', [_c('b-tabs', _vm._l(_vm.tabs, function (tab, i) {
    return _c('b-tab', {
      key: i,
      attrs: {
        "active": i === 0
      },
      scopedSlots: _vm._u([{
        key: "title",
        fn: function fn() {
          return [_c('i', {
            staticClass: "tab.class"
          }), _vm._v(" " + _vm._s(tab.name) + "\n                ")];
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('modal-elements', {
      attrs: {
        "datetimeConfig": _vm.datetimeConfig,
        "element_list": _vm.element_list['segments'][i]['elements'],
        "elements": _vm.tab_values[i]
      }
    })], 1);
  }), 1)], 1) : _c('b-form', _vm._l(_vm.element_list['segments'], function (segment, i) {
    return _c('div', {
      key: i
    }, [(_vm.element_list['segments'][i].hasOwnProperty('section_display') ? _vm.element_list['segments'][i]['section_display'] : true) ? _c('div', [i > 0 ? _c('br') : _vm._e(), _vm._v(" "), segment['header'] ? _c('div', [_c('h5', [_c('i', {
      class: segment['icon']
    }), _vm._v(" " + _vm._s(segment['title']))]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('modal-elements', {
      attrs: {
        "datetimeConfig": _vm.datetimeConfig,
        "element_list": segment['elements'],
        "elements": _vm.elements
      }
    })], 1) : _vm._e()]);
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function () {
    return [_vm._l(_vm.elementListFilter(_vm.element_list['footer']), function (el, i) {
      return _c('button', {
        key: i,
        class: _vm.buttonClass,
        attrs: {
          "type": el.type,
          "disabled": el.spinner
        },
        on: {
          "click": function click($event) {
            return _vm.emit_function(el.onclick);
          }
        }
      }, [el.spinner ? _c('span', {
        staticClass: "spinner-border spinner-border-sm",
        attrs: {
          "role": "status",
          "aria-hidden": "true"
        }
      }) : _vm._e(), _vm._v("\n              " + _vm._s(el.label) + "\n            ")]);
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.$emit('close');
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('close')))])];
  })], 2)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }